var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgMyinvestmentDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 118,
    viewBox: "0 0 230 118",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.491%",
    y1: "17.921%",
    x2: "45.149%",
    y2: "48.649%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDCC3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "16.926%",
    y1: "32.531%",
    x2: "31.469%",
    y2: "41.671%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0E5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "75.049%",
    y1: "24.16%",
    x2: "50.576%",
    y2: "40.13%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5EE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "36.222%",
    y1: "50%",
    x2: "100%",
    y2: "62.012%",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5532",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF934B",
    offset: "83.681%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF934B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "31.571%",
    y1: "58.889%",
    x2: "78.375%",
    y2: "43.429%",
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E3901",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6400",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.156%",
    y1: "94.159%",
    x2: "100%",
    y2: "5.841%",
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5532",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF934B",
    offset: "73.159%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF934B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h230v118H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.883 0c36.938 0 66.882 28.875 66.882 64.494 0 3.46-.282 6.857-.826 10.17-16.146 2.192-39.756 3.575-66.056 3.575-26.3 0-49.91-1.383-66.055-3.575A62.543 62.543 0 0 1 0 64.494C0 28.875 29.944 0 66.883 0z",
    id: "f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.336 1.72c-8.92.012-14.039 11.138-14.77 12.424-1.59 2.793-4.669 5.274-7.02 2.494-1.078-1.275-.12-3.632.717-4.98 1.412-2.277-.468-5.127-3.125-4.773C60.139 8.62 45.261 22.233 48.284 39.592 49.87 48.691 60.871 60.1 79.113 51.546c12.17-6.301 13.769-18.331 16.212-32.42 1.099-6.339 4.02-9.276 6.9-10.588 2.484-1.132 2.555-4.643.052-5.73-1.743-.757-3.378-1.085-4.902-1.088h-.04z",
    id: "k"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-9%",
    y: "-15.3%",
    width: "117.9%",
    height: "130.7%",
    filterUnits: "objectBoundingBox",
    id: "h"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: 5,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.576470588 0 0 0 0 0.294117647 0 0 0 1 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-20.5%",
    y: "-21.8%",
    width: "140.9%",
    height: "143.5%",
    filterUnits: "objectBoundingBox",
    id: "l"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 11,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.638514404 0 0 0 0 0.294117647 0 0 0 1 0",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#b)",
    mask: "url(#c)",
    cx: 30.878,
    cy: 91.441,
    r: 16.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.426 74.037c11.485-11.485 30.106-11.485 41.59 0l.462.472a29.456 29.456 0 0 1 3.917 5.11l.49-.252c16.137-8.246 31.006-8.682 43.087 6.354l.197.247c6.494 8.21 13.012 22.82 3.798 35.706l-.309.428c-9.743 13.411-17.442 13.95-18.048 13.971l-.029.001h-.01l-15.419 15.42-11.93 11.93L70.49 144.69l-.308.285c-10.242 9.316-26.102 9.029-35.996-.865l-.302-.307a26.307 26.307 0 0 1-1.937-2.24c-11.95-1.133-21.299-11.196-21.299-23.443 0-12.542 9.805-22.795 22.167-23.51a29.307 29.307 0 0 1 8.611-20.574z",
    fill: "url(#d)",
    mask: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.567 55.5c20.187 0 36.552 16.365 36.552 36.552 0 1.283-.066 2.55-.195 3.798C224.34 100.734 230 109.844 230 120.276c0 15.588-12.636 28.224-28.224 28.224-12.806 0-23.62-8.53-27.072-20.218-17.888-2.376-31.69-17.691-31.69-36.23 0-20.187 16.366-36.552 36.553-36.552z",
    fill: "url(#e)",
    mask: "url(#c)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.235 44.608)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#g)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#h)",
    xlinkHref: "#f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.567 82.692a2.72 2.72 0 0 1-2.722 2.717 2.72 2.72 0 0 1-2.723-2.717 2.72 2.72 0 0 1 2.723-2.716 2.72 2.72 0 0 1 2.722 2.716M128.913 82.692a2.72 2.72 0 0 1-2.722 2.717 2.72 2.72 0 0 1-2.722-2.717 2.72 2.72 0 0 1 2.722-2.716 2.72 2.72 0 0 1 2.722 2.716",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.944 87.795c-4.464 0-8.083 3.612-8.083 8.067h16.166c0-4.455-3.62-8.067-8.083-8.067",
    fill: "#FFE895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.524 101.354a5.498 5.498 0 0 0 5.503-5.492H110.02a5.498 5.498 0 0 0 5.503 5.492",
    fill: "#FFD36F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.541 29.176c-8.446.006-13.293 4.955-13.985 5.527-1.505 1.243-4.42 2.347-6.647 1.11-1.02-.567-.113-1.616.679-2.216 1.337-1.012-.443-2.28-2.96-2.123-12.307.772-26.395 6.828-23.532 14.55 1.5 4.048 11.918 9.124 29.19 5.319 11.523-2.804 12.5-8.948 16.646-13.76 1.04-2.82 6.036-.85 8.763-1.434 2.351-.503-1.105-6.005-3.475-6.489a23.304 23.304 0 0 0-4.642-.484h-.037z",
    fill: "url(#i)",
    opacity: 0.449,
    transform: "translate(45 10.28)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45 10.28)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#j)",
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#l)",
    xlinkHref: "#k"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgMyinvestmentDefault);
export default __webpack_public_path__ + "static/media/img_myinvestment_default.1ea12a29.svg";
export { ForwardRef as ReactComponent };